const profitabilityCopy = {
  "es": {
    "Rentabilidad": "Rentabilidad",
    "Analiza las ganancias por producto": "Analiza las ganancias por producto",
    "Producto": "Producto",
    "Semana": "Semana",
    "Mes": "Mes",
    "Año": "Año",
    "Costos": "Costos",
    "Ganancia Bruta": "Ganancia Bruta",
    "Margen Promedio": "Margen Promedio",
    "Ingresos y costos por producto": "Ingresos y costos por producto",
    "Los ocho productos con mayor ganancia bruta. Consulta todos los movimientos en la tabla inferior.": "Los ocho productos con mayor ganancia bruta. Consulta todos los movimientos en la tabla inferior.",
    "Rentabilidad por producto": "Rentabilidad por producto",
    "Ganancia bruta según los costos registrados; no incluye los demás gastos del negocio.": "Ganancia bruta según los costos registrados; no incluye los demás gastos del negocio.",
    "Detalle del período": "Detalle del período",
    "Unidades": "Unidades",
    "Ganancia bruta": "Ganancia bruta",
    "Margen": "Margen",
    "No hay ventas de productos en este período.": "No hay ventas de productos en este período.",
    "Ganancia bruta por categoría": "Ganancia bruta por categoría",
    "Una escala común muestra las ganancias y las pérdidas por debajo de cero.": "Una escala común muestra las ganancias y las pérdidas por debajo de cero.",
    "Guía de Márgenes": "Guía de Márgenes",
    "Excelente": "Excelente",
    "Bueno": "Bueno",
    "Regular": "Regular",
    "Bajo": "Bajo",
    "Crítico": "Crítico",
    "Insights": "Insights",
    "{product} es tu producto más rentable con {profit} de ganancia": "{product} es tu producto más rentable con {profit} de ganancia",
    "Tienes {count} productos con margen bajo (<15%). Considera ajustar precios o reducir costos": "Tienes {count} productos con margen bajo (<15%). Considera ajustar precios o reducir costos",
    "Tu margen promedio de {margin} es saludable": "Tu margen promedio de {margin} es saludable",
    "Tu margen promedio de {margin} podría mejorar. Revisa tus precios y costos": "Tu margen promedio de {margin} podría mejorar. Revisa tus precios y costos",
    "Ingresos": "Ingresos",
    "Costo": "Costo",
    "Ganancia": "Ganancia",
    "Margen %": "Margen %",
    "Unidades Vendidas": "Unidades Vendidas",
    "TOTAL": "TOTAL",
    "rentabilidad": "rentabilidad",
    "Ref.": "Ref."
  },
  "en": {
    "Rentabilidad": "Profitability",
    "Analiza las ganancias por producto": "Analyze profit by product",
    "Producto": "Product",
    "Semana": "Week",
    "Mes": "Month",
    "Año": "Year",
    "Costos": "Costs",
    "Ganancia Bruta": "Gross Profit",
    "Margen Promedio": "Average Margin",
    "Ingresos y costos por producto": "Revenue and Costs by Product",
    "Los ocho productos con mayor ganancia bruta. Consulta todos los movimientos en la tabla inferior.": "The eight products with the highest gross profit. See all activity in the table below.",
    "Rentabilidad por producto": "Profitability by Product",
    "Ganancia bruta según los costos registrados; no incluye los demás gastos del negocio.": "Gross profit based on recorded costs; excludes other business expenses.",
    "Detalle del período": "Period Details",
    "Unidades": "Units",
    "Ganancia bruta": "Gross Profit",
    "Margen": "Margin",
    "No hay ventas de productos en este período.": "No product sales in this period.",
    "Ganancia bruta por categoría": "Gross Profit by Category",
    "Una escala común muestra las ganancias y las pérdidas por debajo de cero.": "A shared scale shows profits and losses below zero.",
    "Guía de Márgenes": "Margin Guide",
    "Excelente": "Excellent",
    "Bueno": "Good",
    "Regular": "Fair",
    "Bajo": "Low",
    "Crítico": "Critical",
    "Insights": "Insights",
    "{product} es tu producto más rentable con {profit} de ganancia": "{product} is your most profitable product with {profit} in profit",
    "Tienes {count} productos con margen bajo (<15%). Considera ajustar precios o reducir costos": "You have {count} products with a low margin (<15%). Consider adjusting prices or reducing costs",
    "Tu margen promedio de {margin} es saludable": "Your average margin of {margin} is healthy",
    "Tu margen promedio de {margin} podría mejorar. Revisa tus precios y costos": "Your average margin of {margin} could improve. Review your prices and costs",
    "Ingresos": "Revenue",
    "Costo": "Cost",
    "Ganancia": "Profit",
    "Margen %": "Margin %",
    "Unidades Vendidas": "Units Sold",
    "TOTAL": "TOTAL",
    "rentabilidad": "profitability",
    "Ref.": "Ref."
  },
  "pt": {
    "Rentabilidad": "Rentabilidade",
    "Analiza las ganancias por producto": "Analise o lucro por produto",
    "Producto": "Produto",
    "Semana": "Semana",
    "Mes": "Mês",
    "Año": "Ano",
    "Costos": "Custos",
    "Ganancia Bruta": "Lucro bruto",
    "Margen Promedio": "Margem média",
    "Ingresos y costos por producto": "Receitas e custos por produto",
    "Los ocho productos con mayor ganancia bruta. Consulta todos los movimientos en la tabla inferior.": "Os oito produtos com maior lucro bruto. Consulte todos os movimentos na tabela abaixo.",
    "Rentabilidad por producto": "Rentabilidade por produto",
    "Ganancia bruta según los costos registrados; no incluye los demás gastos del negocio.": "Lucro bruto com base nos custos registrados; não inclui as demais despesas do negócio.",
    "Detalle del período": "Detalhes do período",
    "Unidades": "Unidades",
    "Ganancia bruta": "Lucro bruto",
    "Margen": "Margem",
    "No hay ventas de productos en este período.": "Não há vendas de produtos neste período.",
    "Ganancia bruta por categoría": "Lucro bruto por categoria",
    "Una escala común muestra las ganancias y las pérdidas por debajo de cero.": "Uma escala comum mostra lucros e prejuízos abaixo de zero.",
    "Guía de Márgenes": "Guia de margens",
    "Excelente": "Excelente",
    "Bueno": "Bom",
    "Regular": "Regular",
    "Bajo": "Baixo",
    "Crítico": "Crítico",
    "Insights": "Análises",
    "{product} es tu producto más rentable con {profit} de ganancia": "{product} é seu produto mais rentável, com {profit} de lucro",
    "Tienes {count} productos con margen bajo (<15%). Considera ajustar precios o reducir costos": "Você tem {count} produtos com margem baixa (<15%). Considere ajustar preços ou reduzir custos",
    "Tu margen promedio de {margin} es saludable": "Sua margem média de {margin} é saudável",
    "Tu margen promedio de {margin} podría mejorar. Revisa tus precios y costos": "Sua margem média de {margin} pode melhorar. Revise seus preços e custos",
    "Ingresos": "Receitas",
    "Costo": "Custo",
    "Ganancia": "Lucro",
    "Margen %": "Margem %",
    "Unidades Vendidas": "Unidades vendidas",
    "TOTAL": "TOTAL",
    "rentabilidad": "rentabilidade",
    "Ref.": "Ref."
  },
  "fr": {
    "Rentabilidad": "Rentabilité",
    "Analiza las ganancias por producto": "Analysez les bénéfices par produit",
    "Producto": "Produit",
    "Semana": "Semaine",
    "Mes": "Mois",
    "Año": "Année",
    "Costos": "Coûts",
    "Ganancia Bruta": "Bénéfice brut",
    "Margen Promedio": "Marge moyenne",
    "Ingresos y costos por producto": "Revenus et coûts par produit",
    "Los ocho productos con mayor ganancia bruta. Consulta todos los movimientos en la tabla inferior.": "Les huit produits ayant le bénéfice brut le plus élevé. Consultez toutes les opérations dans le tableau ci-dessous.",
    "Rentabilidad por producto": "Rentabilité par produit",
    "Ganancia bruta según los costos registrados; no incluye los demás gastos del negocio.": "Bénéfice brut selon les coûts enregistrés ; les autres charges de l’entreprise sont exclues.",
    "Detalle del período": "Détail de la période",
    "Unidades": "Unités",
    "Ganancia bruta": "Bénéfice brut",
    "Margen": "Marge",
    "No hay ventas de productos en este período.": "Aucune vente de produits sur cette période.",
    "Ganancia bruta por categoría": "Bénéfice brut par catégorie",
    "Una escala común muestra las ganancias y las pérdidas por debajo de cero.": "Une échelle commune affiche les bénéfices et les pertes sous zéro.",
    "Guía de Márgenes": "Guide des marges",
    "Excelente": "Excellent",
    "Bueno": "Bon",
    "Regular": "Moyen",
    "Bajo": "Faible",
    "Crítico": "Critique",
    "Insights": "Observations",
    "{product} es tu producto más rentable con {profit} de ganancia": "{product} est votre produit le plus rentable, avec un bénéfice de {profit}",
    "Tienes {count} productos con margen bajo (<15%). Considera ajustar precios o reducir costos": "Vous avez {count} produits à faible marge (<15 %). Envisagez d’ajuster les prix ou de réduire les coûts",
    "Tu margen promedio de {margin} es saludable": "Votre marge moyenne de {margin} est satisfaisante",
    "Tu margen promedio de {margin} podría mejorar. Revisa tus precios y costos": "Votre marge moyenne de {margin} pourrait être améliorée. Vérifiez vos prix et vos coûts",
    "Ingresos": "Revenus",
    "Costo": "Coût",
    "Ganancia": "Bénéfice",
    "Margen %": "Marge %",
    "Unidades Vendidas": "Unités vendues",
    "TOTAL": "TOTAL",
    "rentabilidad": "rentabilite",
    "Ref.": "Réf."
  }
};
export default profitabilityCopy;
